import { render, staticRenderFns } from "./CmsAdd.vue?vue&type=template&id=afe5381e&"
import script from "./CmsAdd.vue?vue&type=script&lang=js&"
export * from "./CmsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports